// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsProduct;
(function (HhsProduct) {
    HhsProduct["Descovy"] = "Descovy";
    HhsProduct["Truvada"] = "Truvada";
})(HhsProduct || (HhsProduct = {}));
//# sourceMappingURL=hhsProduct.js.map